// extracted by mini-css-extract-plugin
export default {"p_tye":"f1bd4067e5","slcted":"_96d64799e4","slc_color":"_8e57700b57","item_p":"_7043fb0643","r0":"_1a74b8a5b4"};